<template>
  <section v-if="!isPageLoading" class="design">
    <div class="design__wrapper">
      <div v-for="course in courses" :key="course.id" class="design__course">
        <course-tile
          :course="course"
          :backgroundImg="$getCourseBackground(course, 'small')"
          :gradient="$getGradient()"
          :duration="$duration.getCourseDuration(course)"
          :customClass="'design__course-tile'"
        ></course-tile>
        <div class="design__course-id">{{ course.id }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseTile from '../components/layout/CourseTile.vue'

export default {
  name: 'Debug',
  components: {
    CourseTile,
  },
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      courses: 'courses/allCourses',
    }),
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    await this.$store.dispatch('courses/getAllCourses', 1000)
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.design {
  padding: 150px 25px;
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
  }
  &__course {
    width: 100%;
    @include mobile {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    display: flex;
    flex-wrap: wrap;
  }
  &__course-tile {
    width: 100%;
  }
  &__course-id {
    margin: 0 auto 25px auto;
    color: var(--orange);
  }
}
</style>
